import React, { useMemo } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import PortfolioHeader from './PortFolioHeader';

const MemoizedPortfolioHeader = () => {
  // Select only what's needed for the portfolio header
  const balance = useSelector((state) => state.trade.balance, shallowEqual);
  const bookedPl = useSelector((state) => state.trade.bookedPl, shallowEqual);  
  const blockedMargin = useSelector((state) => state.trade.blockedMargin, shallowEqual);
  const brokerage = useSelector((state) => state.trade.brokerage, shallowEqual);
  const priceChangeConfig = useSelector((state) => state.trade.priceChangeConfig, shallowEqual);
  const showAccountDetails = useSelector((state) => state.trade.showAccountDetails, shallowEqual);
  
  // For active trades
  const userTrades = useSelector((state) => state.trade.userTrades?.OPEN, shallowEqual);
  const quotesData = useSelector((state) => state.trade.quotesData, shallowEqual);
  
  // Calculate active trades with latest price data
  const activeTrades = useMemo(() => 
    (userTrades || []).map((trade) => ({
      ...trade,
      script: { 
        ...trade.script, 
        ...quotesData[trade?.script?.instrument_token] 
      },
    }))
  , [userTrades, quotesData]);
  
  return (
    <PortfolioHeader
      balance={balance}
      bookedPL={bookedPl}
      blockedMargin={blockedMargin}
      brokerage={brokerage}
      activeTrades={activeTrades}
      priceChangeConfig={priceChangeConfig}
      showAccountDetails={showAccountDetails}
    />
  );
};

export default React.memo(MemoizedPortfolioHeader);
